import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { vestigasApi } from '~/services/kyClient';

import { type CodeMessageResponse } from '../types';
import { zodCodeMessageResponseSchema } from '../validations';

/**
 * Reruns a failed/partial execution log for its contact point.
 *
 * @param logId - The id of the execution log entry to rerun.
 * @returns A promise that resolves with the API response.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Data-Subscription
 */
export const rerunExecutionLog = async (
  logId: UUID,
): Promise<CodeMessageResponse> => {
  const response = await vestigasApi
    .post(ENDPOINT.DATA_SUBSCRIPTION.RERUN_EXECUTION_LOG(), {
      searchParams: { logId },
    })
    .json<CodeMessageResponse>();

  const validated = zodCodeMessageResponseSchema.safeParse(response);

  if (!validated.success) {
    console.warn(
      '[rerunExecutionLog] Response validation failed',
      validated.error,
    );
    return response;
  }

  return validated.data;
};
